module.exports = __mpx_resolve_path__("/gaia/workspace-job/git.xiaojukeji.com/ut-prod/train-service/node_modules/@didi/es-mpx-ui/lib/radio/index.mpx?resolve")